import Swiper, { Autoplay, EffectCoverflow, EffectCreative, EffectFade, FreeMode, Navigation, Pagination, Parallax, Thumbs } from 'swiper';
import 'swiper/css';
import SwiperSettings from './swiper-settings';
import SwiperTabs from './swiper-tabs';
import SwiperThumbs from './swiper-thumbs';
export default class SwiperSlider {

  constructor(node) {
    this.node = node;
    this.id = this.node.dataset.swiperId;
    this.type = this.node.dataset.swiperSlider;
    this.params = SwiperSettings.getParams(this.type);
    this.features = SwiperSettings.getFeatures(this.type);
    this.init();
  }

  init() {
    //setting swiper plugins
    Swiper.use([Navigation, Pagination, Autoplay, Parallax, FreeMode, Thumbs, EffectFade, EffectCreative, EffectCoverflow]);

    //gallery with captions and first slide selected
    (this.features.captions || this.features.initSlide) && this.initCaptionsSetup();

    //gallery with captions and first slide selected
    (this.features.customPagination) && this.initCustomPagination();

    (this.features.navCheck) && this.initNavCheck();

    //Outside controls
    (this.features.outsideControls) && this.initOutsideControls();

    //gallery with thumbs
    if(this.features.thumbs){
      if (this.type === 'coverSlider') {
        this.initThumbs();
        return;
      } else if(!document.body.classList.contains('mobile')) {
        this.initThumbs();
        return;
      }
    };

    if(this.features.tabs) {
      this.initTabs();
      return;
    }

    //swiper init
    this.swiper = new Swiper(this.node, this.params);
  }

  initTabs() {
    this.thumbs = new SwiperTabs(this.node, this.id);
		this.swiper = new Swiper(this.node, this.params);
		this.thumbs.bindSliders();
  }

  //THUMBS
  initThumbs() {
		this.thumbs = new SwiperThumbs(this.node, this.id);
		this.params = Object.assign(this.params, {
			thumbs: {
				swiper: this.thumbs.instance.swiper
			}
		});
		this.swiper = new Swiper(this.node, this.params);
		this.thumbs.bindSliders();
	}

  //CAPTIONS
  initCaptionsSetup() {
    this.captions = document.querySelector('[data-captions]');
    this.captionsWrapper = document.querySelector('[data-captions-wrapper]');
    this.captionsItems = Array.from(document.querySelectorAll('[data-caption-id]'));
    this.params = Object.assign(this.params, {
      on: {
        slideChange: (swiper) => {
          this.features.captions && this.setCaption(swiper);
        },
        init: (swiper) => {
          this.features.initSlide && this.setSlide(swiper)
          this.features.captions && this.setCaption(swiper);
        }
      }
    })
  }

  setCaption(swiper) {
    const currentItem = this.captionsItems[swiper.realIndex];
    const currentHeight = currentItem.clientHeight;
    this.captions.style.height = currentHeight + 'px';
    this.captionsWrapper.style.transform = `translateY(-${currentItem.offsetTop}px)`;
  }

  setSlide(swiper) {
    const clickedItem = swiper.wrapperEl.querySelector('[data-gallery-active]');
    clickedItem.dataset.galleryId && swiper.slideTo(parseInt(clickedItem.dataset.galleryId, 10), 0)
  }

  initOutsideControls() {
    const wrapper = this.node.closest('[data-module]');
    const controlprev = wrapper.querySelector('.swiper-button-prev');
    const controlnext = wrapper.querySelector('.swiper-button-next')

    this.params = Object.assign(this.params, {
      navigation: {
        nextEl: controlnext,
        prevEl: controlprev
      },
		});
  }

  //CUSTOM PAGINATION
  initCustomPagination() {
    const wrapper = this.node.closest('[data-module]')
    const images = wrapper.querySelectorAll('[data-swiper-thumbnail]');
    const pagination = wrapper.querySelector('.swiper-pagination')
    const autoplayTimer = 4000;

    this.params = Object.assign(this.params, {
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: (index, className) => {
          const paginationHTML = `
            <div class="${className}">
              <div class="cover-border">
                <div class="cover-border__text"><div class="_label-3">0${index + 1}</div></div>
                <div class="cover-border__image"><div class="media">${images[index].outerHTML}</div></div>
                <div class="cover-border__svg">
                  <svg viewBox="0 0 119.8 200" data-swiper-border>
                    <path class="cover-border__bg" d="M7.9,61.9c0-28.7,23.3-51.9,52-51.9s52,23.2,52,51.9v76.3c0,28.6-23.3,51.9-52,51.9s-52-23.2-52-51.9V61.9z"/>
                    <path class="cover-border__path" data-swiper-border-path d="M59.9,10c28.7,0,52,23.2,52,51.9v76.3c0,28.6-23.3,51.9-52,51.9s-52-23.2-52-51.9V61.9C7.9,33.2,31.2,10,59.9,10"/>
                  </svg>
                </div>
              </div>
            </div>
          `;
          return paginationHTML;
        },
      },
      autoplay: {
        delay: autoplayTimer,
        disableOnInteraction: false,
      },
      on: {
        init: (swiper) => {
          this.setActivePagination(swiper, wrapper, autoplayTimer)
          this.setClaim(swiper, wrapper)
        },
        slideChange: (swiper) => {
          this.setActivePagination(swiper, wrapper, autoplayTimer);
          this.setClaim(swiper, wrapper)
        },
      },
		});
  }

  setClaim(swiper, wrapper) {
    const claimsMask = wrapper.querySelector('[data-swiper-claim]');
    const claimWrap = wrapper.querySelector('[data-swiper-claim] .cover__claim-wrap')
    const claimItems = wrapper.querySelectorAll('[data-swiper-claim] .cover__claim-item');
    const current = claimItems[swiper.activeIndex];
    const currentHeight = current.clientHeight;
    claimsMask.style.height = currentHeight + 'px';
    claimWrap.style.transform = `translateY(-${currentHeight * swiper.activeIndex}px)`;
  }

  setActivePagination(swiper, wrapper, autoplayTimer) {
    const borderPath = wrapper.querySelectorAll('.swiper-pagination [data-swiper-border-path]');
    const current = borderPath[swiper.activeIndex];
    const currentLength = current.getTotalLength();
    current.style.strokeDasharray = current.getTotalLength();
    current.animate([
      { strokeDashoffset: currentLength },
      { strokeDashoffset: 0 }
    ], {
      duration: autoplayTimer,
      iterations: 1
    });
  }

  //NAV CHECK
  initNavCheck() {
    const wrapper = this.node.closest('[data-module]')
    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length <= this.params.slidesPerView) {
      const buttons = wrapper.querySelector('.carousel__buttons');
      buttons.style.display = 'none';
    }
  }

  static init(context) {
    const node = context ? context : document;
    const sliders = Array.from(
      node.querySelectorAll('[data-swiper-slider]')).filter(
        item => item.dataset.swiperSlider !== 'controls' && item.dataset.swiperSlider !== 'tabs'
      );

    SwiperSlider.item = sliders.map((node, index) => new SwiperSlider(node, index));
    return SwiperSlider.item;
  }
}
